import posthog from "posthog-js";

export const initPosthog = () => {
  const posthogApiKey = process.env.NEXT_PUBLIC_POSTHOG_API_KEY;
  const env = process.env.NEXT_PUBLIC_ENV;
  if (
    window.location.host.includes("127.0.0.1") ||
    window.location.host.includes("localhost") ||
    env === "development" ||
    env === "staging"
  ) {
    return;
  }
  if (!posthogApiKey) return;
  posthog.init(posthogApiKey, {
    api_host: "https://us.i.posthog.com",
    person_profiles: "identified_only",
  });
};
